var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 갤러리 상세 페이지"),_c('br'),_c('button',[_vm._v("X(삭제)")])])
}]

export { render, staticRenderFns }